import { h } from 'preact'
import CodeMirror from '../codemirror'

type Props = {
  content: string,
  onContentChange: (html: string) => void,
  contentForPreview?: string
}

export const RawEmailEditor = ({ content, onContentChange, contentForPreview } : Props) => {
  return (
    <div className='raw-email-editor'>
      <div className='raw-email-editor-wrapper'>
        <div className='raw-email-editor__preview-wrapper'>
          <label>Email preview</label>
          <div
            className='raw-email-editor__preview'
            dangerouslySetInnerHTML={{ __html: contentForPreview || content }}
          />
        </div>
        <div>
          <label>Custom HTML</label>
          <CodeMirror
            defaultValue={content}
            onChange={(html: string) => onContentChange(html)}
            options={{
              lineNumbers: true,
              mode: 'text/html',
              selectionPointer: true,
              autoRefresh: true,
              autoResize: true
            }}
          />
        </div>
      </div>
    </div>
  )
}
